// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-64d38c74]{font-size:2em}section[data-v-64d38c74]{padding-top:60px;padding-bottom:60px}", ""]);
// Exports
module.exports = exports;
